import { render } from "./LeaderboardView.vue?vue&type=template&id=29cf742d&scoped=true"
import script from "./LeaderboardView.vue?vue&type=script&lang=js"
export * from "./LeaderboardView.vue?vue&type=script&lang=js"

import "./LeaderboardView.vue?vue&type=style&index=0&id=29cf742d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29cf742d"]])

export default __exports__